export const PRICE_PLANS_API = '/api/dashboard/customer/price-plans'
